import {styled} from '@linaria/react';
import {BaseUnstyledLink} from './BaseUnstyledLink';

export const UnstyledLink = styled(BaseUnstyledLink)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
